const NZUltra = () => {
  return (
    <>
      {" "}
      <div className="pt-[86px] pb-[65px] bg-[#f6f6f6]">
        <div className="md:max-w-[80%] max-w-full mx-auto py-[30px]">
          <div className="custom-container px-[30px] text-center">
            <div className=" max-w-[1220px] mx-auto">
              <div className="kuunari-bold 2xl:text-[70px] lg:text-[66px] md:text-[55px] text-[40px]	lg:mb-[20px] sm:mb-[20px] text-[#383838] leading-[1em] mb-[10px]">
              Off-Road Utility Vehicle (UTV)
              </div>
              <h3 className="montserrat-semi-bold  text-[22px] text-[#383838] leading-[1em] mb-[16px]">
              Simple Engineering Design Means Easy Maintenance 
              </h3>
              <p className="montserrat-medium   text-[#383838] leading-[26px]  text-[16px] mb-[16px]">
                The Tuatara has often been compared to the 1950s Land Rover or even the Willys Jeep, and we're happy
                with those comparisons. In fact, in terms of where it will go, we're sure that the Tuatara would be a
                match for either.
              </p>
              <br />
              {/* <p className="montserrat-medium   text-[#383838] leading-[26px]  text-[16px] mb-[16px]">
                If it's a steep climb to be tackled, there's no need to get a run on. Just apply a low gear, and the
                Tuatara ATV vehicle will use its big fat high-grip tyres and differential lock on each axle, if needed,
                to casually climb to the top.
              </p>
              <br /> */}
              <p className="montserrat-medium   text-[#383838] leading-[26px]  text-[16px] mb-[16px]">
                But it's not just its capability and all-steel design that invites the comparison with these two
                off-road icons of the past. It's also the <strong>simple engineering design</strong> of the Tuatara and
                its <strong>ease of access for servicing.</strong> You can do a lot of the  servicing yourself or save big by taking
                the Tuatara straight to your local garage. There is no need to foot huge servicing and repair costs
                that many of the  multi-national ATV suppliers are charging.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default NZUltra;
